import { blue, gray, green, grey } from '@ant-design/colors';
import { Button, Flex, Switch, Tag, Tooltip, message } from 'antd';
import { ClockCircleOutlined, PauseOutlined } from '@ant-design/icons';
import { useState } from 'react';
import ConfirmModal from '../ConfirmModal';
import dayjs from 'dayjs';
import Wrapper from '../Wrapper';
import ChangePlanModal from './ChangePlanModal';
import { SubscriptionAttrs } from '@next-is-free-monorepo/next-is-free-types';
import { Stripe } from 'stripe';
import { useMutation, UseMutationOptions, useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { apiV1 } from '../../utils/apiClient';
import React from 'react';
import CModal from '../CModal';
import { IconRefreshOff } from '@tabler/icons-react';
import { subscriptionQueryOptions } from '../../utils/queryOptions';


const SubscriptionOverview = () => {

  const {data: subscription} = useSuspenseQuery(subscriptionQueryOptions());

  const [autoRenewModalOpen, setAutoRenewModalOpen] = useState(false);
  const [cancelRenewModalOpen, setCancelRenewModalOpen] = useState(false);
  const [changePlanModalOpen, setChangePlanModalOpen] = useState(false);

  const queryClient = useQueryClient();
  const toggleAutoRenewMutation: UseMutationOptions = {
    mutationKey: ['subscription', 'renew'],
    mutationFn: async () => apiV1.put(`/shop/subscription/${subscription.id}/auto-renew/${subscription.cancel_at_period_end}`, {}),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['upcoming-invoice'] });
      message.success('Impostazioni di rinnovo aggiornate')
      setAutoRenewModalOpen(false);
      setCancelRenewModalOpen(false);
    },
    onSettled: async ()=>{
      await queryClient.invalidateQueries({ queryKey: ['subscription']});
    }
  };

  const toggleAutoRenew = useMutation(toggleAutoRenewMutation);

  return (
    <div>
      {subscription.status === 'trialing' &&
        <div
          style={{ backgroundColor: blue[0], padding: 20, borderRadius: 20, color: blue[4], marginBottom: 15 }}>
          <Flex align={'center'}>
            <div>
              <ClockCircleOutlined style={{ fontSize: 20, marginRight: 10 }} />
            </div>
            <div>
              <p style={{ fontWeight: 600 }}>La prova gratuita scadrà tra {subscription.trial_days_left} giorni</p>
            </div>
          </Flex>
        </div>
      }
      <Wrapper title={'Piano attuale'}>
        <div className={'flex justify-between items-start'}>
          <div>
            <p className={'text-xl'}>Abbonamento {subscription.interval === 'month' ? 'Mensile' : 'Annuale'}</p>
            {subscription.extra_sales_points_number > 0 &&
              <p>+{subscription.extra_sales_points_number} Punt{subscription.extra_sales_points_number === 1 ? 'o' : 'i'} vendita
                extra</p>
            }
          </div>
          <SubscriptionStatusCip status={subscription.status} />
        </div>
        <div>
          {subscription.cancel_at ?
            <p className={'bg-amber-50 w-fit pt-0.5 px-1 text-amber-500 mt-3 border border-amber-200 rounded-md'}>L'abbonamento terminerà
              il {dayjs(subscription.cancel_at * 1000).format('DD/MM/YY')} e non sarà rinnovato</p> :
            <p style={{ marginTop: 6, color: grey[2] }}>L'abbonamento sarà rinnovato automaticamente
              il {subscription.renewal_date}</p>
          }
        </div>
        <div className={'flex justify-end gap-2 mt-5'}>
          {subscription.cancel_at ?
            <Button loading={toggleAutoRenew.isPending} onClick={() => toggleAutoRenew.mutate()}>Attiva rinnovo automatico</Button> :
            <Button onClick={() => setCancelRenewModalOpen(true)}>Disattiva rinnovo automatico</Button>
          }
          <Button type={'primary'} onClick={() => {
            setChangePlanModalOpen(true);
          }}>Modifica abbonamento</Button>
        </div>
      </Wrapper>
      <CModal title={'Disattivare il rinnovo?'}
              text={' L\'abbonamento sarà annullato al termine del periodo di fatturazione\n' +
                '          corrente.'} color={'red'} confirmButtonText={'Disattiva'} cancelButtonText={'Non disattivare'} open={cancelRenewModalOpen}
              onClose={() => setCancelRenewModalOpen(false)}
              icon={<IconRefreshOff />} mutationOptions={toggleAutoRenewMutation} />
      <ChangePlanModal open={changePlanModalOpen} setChangePlanModal={setChangePlanModalOpen}
                       subscriptionInterval={subscription.interval} />
    </div>

  );
};
export default SubscriptionOverview;

function SubscriptionStatusCip({ status }: { status: Stripe.Subscription.Status }) {

  switch (status) {
    case 'active':
      return (
        <p className={'bg-green-100 text-green-700 px-2 text-sm py-0.5 rounded-md'}>
          Attivo
        </p>
      );
    case 'unpaid':
      return (
        <p className={'bg-red-100 text-red-700 px-2 text-sm py-0.5 rounded-md'}>
          Insoluto
        </p>
      );
    case 'past_due':
      return (
        <Tooltip
          title={'Una o più fatture non sono state pagate. Controlla tra le fatture. Se una fattura è in sospeso significa che la banca sta ancora processando il pagamento, lo stato dell abbonamento tornerà attivo non appena il pagamento sarà completato, nel frattempo puoi continuare a usare Next is free senza interruzioni'}>
          <p className={'bg-red-100 text-red-700 px-2 text-sm py-0.5 rounded-md'}>
            Insoluto
          </p>
        </Tooltip>
      );
    case 'trialing':
      return (
        <p className={'bg-blue-100 text-blue-700 px-2 text-sm py-0.5 rounded-md'}>
          In prova
        </p>
      );

    default:
      return (
        <p className={'bg-blue-100 text-blue-700 px-2 text-sm py-0.5 rounded-md'}>
          Scaduto
        </p>
      );
  }

}
